/**
 * 从layer中获取下一个zIndex的值
 */
export const nextZIndex = function () {
  let zIndex = 100;
  return function () {
    if (!layer.zIndex) {
      return ++zIndex;
    }
    layer.config({"zIndex": ++layer.zIndex});
    return layer.zIndex;
  };
}();



// WEBPACK FOOTER //
// ./src/js/utils/zIndexUtil.js